import { Component, inject } from '@angular/core';
import { ToastService } from '../../services';
import { ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.html',
  styleUrl: './toast.css',
})
export class Toast {
  toastService = inject(ToastService);

  /** Spoken before the message by screen readers */
  readonly kindLabel: Record<ToastType, string> = {
    success: 'Listo',
    error: 'Error',
    warning: 'Atención',
    info: 'Aviso',
  };
}
